import * as Types from "../action.types"
import * as Models from "../../models/index"
import { validateUserPassword, validateOldPassword } from "./pwd.validate"
import * as Services from './../../service/index'
import * as toastr from "toastr"

export const setDefault = () => ({
    type: Types.PWD_SET_DEFAULT
});

export const changeOldPassword = (value: string) => (d: Function, gs: () => Models.StoreState) => {
    d({
        type: Types.PWD_EXPIRED_UPDATE_OLD_PASSWORD,
        payload: value
    });

    let equal = gs().pwdValidate.isNeededValidation;

    d({
        type: Types.PWD_UPDATE_IS_NEEDED_VALIDATION,
        payload: true
    })

    if (equal !== gs().pwdValidate.isNeededValidation) {
        d(validateOldPassword())
    }
}

export const changePassword = (value: string, isPwd = false, isExpired = false) => (d: Function, gs: () => Models.StoreState) => {
    d({
        type: isPwd ? Types.PWD_UPDATE_PASSWORD : Types.PWD_UPDATE_CONFIRM_PASSWORD,
        payload: value
    });

    let equal = gs().pwdValidate.matchingPwd;
    let nextEqualityFlag = gs().pwdSecurity.password === gs().pwdSecurity.confirmPassword

    d({
        type: Types.PWD_UPDATE_MATCHING_PASSWORD_AND_CONFIRM,
        payload: nextEqualityFlag
    })

    if (equal !== gs().pwdValidate.matchingPwd) {
        d(validateUserPassword(isExpired));
    }
}

export const checkSecretAnswersByUserName = () => (d: Function, gs: () => Models.StoreState) => {
    Services.Recovery.checkResetAnswersByUserName({ userName: gs().login.userName })
        .then(response => {
            d({
                type: Types.SET_SECRET_QUESTIONS,
                payload: response
            })
        })
}

export const changePasswordAndSubmitSecretAnswers = () => (d: Function, gs: () => Models.StoreState) => {
    d({
        type: Types.PWD_EXPIRED_PENDING
    });

    Services.Recovery.changePasswordAndSubmitSecretAnswers({
        username: gs().login.userName,
        oldPassword: gs().pwdSecurity.oldPassword,
        newPassword: gs().pwdSecurity.password,
        confirmPassword: gs().pwdSecurity.confirmPassword,
        isNeedToChangePwd: gs().login.isNeededToChangePWD,
        answers: gs().pwdSecurity.answers
    }).then(response => {
        if (response.isSuccess) {
            toastr.success(response.message);
        }
        else {
            toastr.warning(response.message)
        }

        if (response.isSuccess) {
            window.location.href = "/login";
        }
    })
}

export const showSecretQuestions = () => ({
    type: Types.CHANGE_VISIBLE_SELECT_SECRET_QUESTION
})

export const updateSecretAnswers = (questionId: string, answerId: string) => {

    return ({
        type: Types.PWD_UPDATE_SECRET_ANSWERS,
        payload: {
            questionId,
            answerId
        }
    })
}

export const changeSecretAnswerText = (answerId: string, answerText: string) => {
    return ({
        type: Types.PWD_UPDATE_SECRET_ANSWER_TEXT,
        payload: {
            answerId,
            answerText
        }
    })
}